import { render, staticRenderFns } from "./log-create.vue?vue&type=template&id=6a7d64fa"
import script from "./log-create.vue?vue&type=script&lang=js"
export * from "./log-create.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/add/add.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports